import PointsAlert from './PointsAlert';

export default PointsAlert;
